module.exports = __webpack_public_path__ + "assets/cameraShutter@3x.9fc1ddafc00473de03d113902bda9463.png";